import { useLocalStorage } from '../useLocalStorage';
import { useMediaQuery } from '../useMediaQuery';
const COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)';
const LOCAL_STORAGE_KEY = 'usehooks-ts-ternary-dark-mode';
export function useTernaryDarkMode(options) {
    var _a, _b, _c;
    const defaultValue = typeof options === 'string' ? 'system' : (_a = options === null || options === void 0 ? void 0 : options.defaultValue) !== null && _a !== void 0 ? _a : 'system';
    const localStorageKey = typeof options === 'string'
        ? options
        : (_b = options === null || options === void 0 ? void 0 : options.localStorageKey) !== null && _b !== void 0 ? _b : LOCAL_STORAGE_KEY;
    const initializeWithValue = typeof options === 'string'
        ? undefined
        : (_c = options === null || options === void 0 ? void 0 : options.initializeWithValue) !== null && _c !== void 0 ? _c : undefined;
    const isDarkOS = useMediaQuery(COLOR_SCHEME_QUERY);
    const [mode, setMode] = useLocalStorage(localStorageKey, defaultValue, {
        initializeWithValue,
    });
    const isDarkMode = mode === 'dark' || (mode === 'system' && isDarkOS);
    const toggleTernaryDarkMode = () => {
        const modes = ['light', 'system', 'dark'];
        setMode(prevMode => {
            return modes[(modes.indexOf(prevMode) + 1) % modes.length];
        });
    };
    return {
        isDarkMode,
        ternaryDarkMode: mode,
        setTernaryDarkMode: setMode,
        toggleTernaryDarkMode,
    };
}
